module.exports = __webpack_public_path__ + "img/social-media.d34fe635.png";